<template>
	<div class="filter mt-3">
		<div v-if="loading" class="spinner-wrap">
			<div class="spinner"></div>
		</div>
		<h2 class="title">
			{{ title || 'PROPIEDADES EN' }} <b>VENTA Y ALQUILER</b>
		</h2>
		<form class="filter-form" @submit.prevent="search">
			<div class="form-row">
				<div class="col-6 col-lg-3 form-group mb-2">
					<treeselect
						v-model="transaction_type_id"
						:placeholder="'Operacion'"
						:options="options.transaction_types"
					/>
				</div>
				<div class="col-6 col-lg-3 form-group mb-2">
					<treeselect
						v-bind="commons"
						v-model="property_type_id"
						placeholder="Propiedad"
						:options="options.property_types"
					/>
				</div>
				<div class="col-6 col-lg-3 form-group mb-2">
					<treeselect
						v-bind="commons"
						v-model="rooms"
						placeholder="Ambientes"
						:options="options.rooms"
					/>
				</div>
				<div class="col-6 col-lg-3 form-group mb-2">
					<treeselect
						v-bind="commons"
						v-model="bedrooms"
						placeholder="Dormitorios"
						:options="options.bedrooms"
					/>
				</div>
				<div class="col-6 col-lg-2 form-group mb-2">
					<treeselect
						v-bind="commons"
						v-model="bathrooms"
						placeholder="Baños"
						:options="options.bathrooms"
					/>
				</div>
				<div class="col-6 col-sm-3 col-lg-2 form-group mb-2">
					<label class="sr-only" for="desde">Desde</label>
					<input
						type="number"
						id="desde"
						class="form-control"
						step="1000"
						v-model="minPrice"
						placeholder="Desde"
					/>
				</div>
				<div class="col-6 col-sm-3 col-lg-2 form-group mb-2">
					<label class="sr-only" for="hasta">Hasta</label>
					<input
						type="number"
						id="hasta"
						class="form-control"
						step="1000"
						v-model="maxPrice"
						placeholder="Hasta"
					/>
				</div>
				<div class="col-6 col-sm-3 col-lg-2 form-group mb-2">
					<label class="sr-only" for="hasta">Nro Referencia #</label>
					<input
						type="number"
						id="hasta"
						class="form-control"
						step="1000"
						v-model="reference"
						placeholder="Nro Referencia #"
					/>
				</div>
				<div class="col-auto my-2">
					<div class="form-check">
						<input
							class="form-check-input"
							type="checkbox"
							id="acceptCredit"
						/>
						<label class="form-check-label" for="acceptCredit"
							>Apto Crédito</label
						>
					</div>
				</div>
				<div class="col-auto my-1 ml-auto">
					<button type="submit" class="btn btn-filter">
						Buscar Ahora <i class="icon-angle-double-right"></i>
					</button>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
	import Treeselect from '@riophae/vue-treeselect'
	import { getSettings } from '../../../Inmokey'

	export default {
		name: 'Filter',
		components: { Treeselect },
		props: ['title'],
		data() {
			return {
				loading: true,
				commons: {
					multiple: true,
					limit: 3,
					limitText: count => `${count} más`,
					noOptionsText: 'No hay opciones disponibles',
					noResultsText: 'No se encuentran resultados'
				},
				transaction_type_id: null,
				property_type_id: [],
				accept_credit: null,
				city_id: null,
				neighborhood_id: [],
				rooms: [],
				bedrooms: [],
				bathrooms: [],
				garages: [],
				currency: null,
				minPrice: null,
				maxPrice: null,
				reference: null,
				options: {
					rooms: [
						{ id: 1, label: '1 Amb.' },
						{ id: 2, label: '2 Amb.' },
						{ id: 3, label: '3 Amb.' },
						{ id: 4, label: '4 Amb.' },
						{ id: '5,6,7,8,9,10', label: '+5 Amb' }
					],
					bedrooms: [
						{ id: 1, label: '1 Dorm.' },
						{ id: 2, label: '2 Dorm.' },
						{ id: 3, label: '3 Dorm.' },
						{ id: 4, label: '4 Dorm.' },
						{ id: '5,6,7,8,9,10', label: '+5 Dorm' }
					],
					bathrooms: [
						{ id: 1, label: '1 Baño' },
						{ id: 2, label: '2 Baños' },
						{ id: 3, label: '3 Baños' },
						{ id: 4, label: '4 Baños' },
						{ id: '5,6,7,8,9,10', label: '+5 Baños' }
					],
					garages: [
						{ id: 1, label: '1 Cochera' },
						{ id: 2, label: '2 Cocheras' },
						{ id: 3, label: '3 Cocheras' },
						{ id: 4, label: '4 Cocheras' },
						{ id: '5,6,7,8,9,10', label: '+5 Cocheras' }
					],
					neighborhoods: [],
					currencies: [],
					property_types: [],
					cities: [],
					transaction_types: []
				}
			}
		},
		methods: {
			search() {
				var params = {
					pageSize: 8
				}

				if (this.transaction_type_id) {
					params.transactionType = this.transaction_type_id
				}
				if (this.property_type_id.length) {
					params.propertyType =
						'[' + this.property_type_id.join(',') + ']'
				}

				if (this.rooms.length) {
					params.rooms = '[' + this.rooms.join(',') + ']'
				}

				if (this.bedrooms.length) {
					params.bedrooms = '[' + this.bedrooms.join(',') + ']'
				}

				if (this.bathrooms.length) {
					params.bathrooms = '[' + this.bathrooms.join(',') + ']'
				}

				if (this.accept_credit !== null) {
					params.accept_credit = this.accept_credit
				}

				if (this.minPrice !== null) {
					params.minPrice = this.minPrice
				}

				if (this.maxPrice !== null) {
					params.maxPrice = this.maxPrice
				}

				if (this.reference !== null) {
					params.reference = this.reference
				}

				window.location.replace(
					this.$router.resolve({
						path: '/propiedades',
						query: { ...this.$router.query, ...params }
					}).href
				)
			}
		},
		beforeMount() {
			getSettings(
				({
					property_types,
					cities,
					neighborhoods,
					transaction_types,
					currencies
				}) => {
					this.options.property_types = Object.entries(
						property_types
					).map(([id, value]) => ({
						id,
						label: value.name
					}))
					this.options.cities = Object.entries(cities)
						.filter(([id, value]) => value.name.trim())
						.map(([id, value]) => ({
							id,
							label: value.name
						}))
					this.options.neighborhoods = Object.entries(neighborhoods)
						.filter(([id, value]) => value.name.trim())
						.map(([id, value]) => ({
							id,
							label: value.name,
							city_id: value.city_id
						}))
					this.options.transaction_types = Object.entries(
						transaction_types
					).map(([id, value]) => ({
						id,
						label: value.name
					}))
					this.options.currencies = currencies
					this.loading = false
				}
			)
		}
	}
</script>
